import { formatVerbiage, getItems, useFilterItemQuery } from "@repo/helpers";
import { useMemo } from "react";

import { IActiveLists } from "./logic";

const AUDIT_TYPE = [
	{ id: 1, value: "Field Audit" },
	{ id: 2, value: "Prospect Interview" },
	{ id: 3, value: "Secret Shopper" },
];

const YES_NO_NA = [
	{ id: 0, value: "Yes" },
	{ id: 1, value: "No" },
	{ id: 2, value: "N/A" },
];

const YES_NO_NOT_APPLICABLE = [
	{ id: 0, value: "Yes" },
	{ id: 1, value: "No" },
	{ id: 2, value: "Did not observe" },
];

const YES_NO = [
	{ id: 0, value: "Yes" },
	{ id: 1, value: "No" },
];

const RETAIL_SHOP_TYPE = [
	{ id: 1, value: "WM Buildout" },
	{ id: 2, value: "Store Front" },
	{ id: 3, value: "Kiosk" },
];

export function useSharedRepFieldAuditsLists({
	useFormTypesQuery,
	useQuestionOptionsQuery,
	useComplaintTypesQuery,
	useLocationsQuery,
	getReps,
	useSettingsQuery,
	coords,
}: {
	useFormTypesQuery: any;
	useQuestionOptionsQuery: any;
	useComplaintTypesQuery?: any;
	useLocationsQuery: any;
	getReps: any;
	useSettingsQuery: any;
	coords?: { latitude: number; longitude: number };
}) {
	const [reps, repsLoaded] = useFilterItemQuery(["REPS"], getReps);
	const { data: formTypes, loaded: formTypesLoaded } = useFormTypesQuery();
	const { data: api, loaded: apiLoaded } = useQuestionOptionsQuery();
	const { data: FieldAuditComplaintTypes, loaded: complaintTypesLoaded = true } = useComplaintTypesQuery?.() ?? {};
	const { data: locations, loaded: locationsLoaded } = useLocationsQuery(coords?.latitude, coords?.longitude);
	const { data: settings, loaded: settingsLoaded } = useSettingsQuery();
	const { verbiage } = settings ?? {};

	const activeLists: IActiveLists = useMemo(() => {
		return {
			auditType: AUDIT_TYPE.map(({ id, value }) => ({ id, value: formatVerbiage(value, verbiage) })),
			yesNoNA: YES_NO_NA,
			yesNoNotApplicable: YES_NO_NOT_APPLICABLE,
			yesNo: YES_NO,
			retailShopTypes: RETAIL_SHOP_TYPE,
			formType: formTypes?.map(({ id, value }: any) => ({ id, value: formatVerbiage(value, verbiage) })),
			reps: getItems(reps, repsLoaded),
			api,
			FieldAuditComplaintTypes,
			verbiage,
			locations,
		};
	}, [formTypes, api, FieldAuditComplaintTypes, locations, reps, repsLoaded, verbiage]);

	const loaded =
		repsLoaded && formTypesLoaded && apiLoaded && complaintTypesLoaded && locationsLoaded && settingsLoaded;

	return [activeLists, loaded] as const;
}
